import {
  ActionIcon,
  Container,
  Group,
  Image,
  Text,
  em,
  rem,
} from "@mantine/core";

import { useIsMobile } from "hooks";
import {
  IconBrandInstagram,
  IconBrandTwitter,
  IconBrandYoutube,
} from "@tabler/icons-react";
import logo from "Assets/logo.png";
import classes from "./Footer.module.css";
import { Link } from "react-router-dom";

const data = [
  {
    title: "About",
    links: [
      { label: "Features", link: "#" },
      { label: "Pricing", link: "#" },
      { label: "Support", link: "#" },
      { label: "Forums", link: "#" },
    ],
  },
  {
    title: "Project",
    links: [
      { label: "Contribute", link: "#" },
      { label: "Media assets", link: "#" },
      { label: "Changelog", link: "#" },
      { label: "Releases", link: "#" },
    ],
  },
  {
    title: "Community",
    links: [
      { label: "Join Discord", link: "#" },
      { label: "Follow on Twitter", link: "#" },
      { label: "Email newsletter", link: "#" },
      { label: "GitHub discussions", link: "#" },
    ],
  },
];

type Props = {
  brandName: string;
};

const Footer = ({ brandName }: Props) => {
  const isMobile = useIsMobile();

  const groups = data.map((group) => {
    const links = group.links.map((link, index) => (
      <Text
        key={index}
        className={classes.link}
        component="a"
        href={link.link}
        onClick={(event) => event.preventDefault()}
      >
        {link.label}
      </Text>
    ));

    return (
      <div className={classes.wrapper} key={group.title}>
        <Text className={classes.title}>{group.title}</Text>
        {links}
      </div>
    );
  });

  return (
    <footer className={classes.footer}>
      <Container className={classes.inner}>
        <div className={classes.logo}>
          <Link to="/" style={{ textDecoration: "none" }}>
            <Group gap={5} justify="center" align="center" h={60}>
              <Image h={isMobile ? 40 : 60} src={logo} alt="" />
              <Text
                // size='32px'
                fz={isMobile ? 16 : 32}
                fw={700}
                variant="gradient"
                gradient={{
                  from: "var(--mantine-color-secondary-filled)",
                  to: "var(--mantine-primary-color-filled)",
                  deg: 90,
                }}
              >
                {brandName}
              </Text>
            </Group>
          </Link>
          <Text size="xs" c="dimmed" className={classes.description}>
            Selling only the best things online
          </Text>
        </div>
        <div className={classes.groups}>{groups}</div>
      </Container>
      <Container className={classes.afterFooter}>
        <Text c="dimmed" size="sm">
          © 2024 shopit.com. All rights reserved.
        </Text>

        <Group
          gap={0}
          className={classes.social}
          justify="flex-end"
          wrap="nowrap"
        >
          <ActionIcon size="lg" color="gray" variant="subtle">
            <IconBrandTwitter
              style={{ width: rem(18), height: rem(18) }}
              stroke={1.5}
            />
          </ActionIcon>
          <ActionIcon size="lg" color="gray" variant="subtle">
            <IconBrandYoutube
              style={{ width: rem(18), height: rem(18) }}
              stroke={1.5}
            />
          </ActionIcon>
          <ActionIcon size="lg" color="gray" variant="subtle">
            <IconBrandInstagram
              style={{ width: rem(18), height: rem(18) }}
              stroke={1.5}
            />
          </ActionIcon>
        </Group>
      </Container>
    </footer>
  );
};
export default Footer;
